<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>资产订单</span>
          </div>
          <div class="form-container">
            <el-form :model="assetInventoryInInfo" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="选择仓库">
                    <el-select 
                      v-model="assetInventoryInInfo.shId" 
                      placeholder="请选择仓库"
                      style="width:100%"
                    >
                      <el-option 
                        v-for="item in assetInventoryInInfo.shopHouses"
                        :key="item.shId"
                        :label="item.shName"
                        :value="item.shId"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="盘点日期">
                    <el-date-picker
                      v-model="assetInventoryInInfo.invTime"
                      type="datetime"
                      placeholder="选择日期时间"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width:100%"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="盘点说明">
                    <el-input
                      v-model="assetInventoryInInfo.remark"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入盘点说明"
                      maxlength="250"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row style="margin-top:20px">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>盘点商品</span>
            <el-button 
              type="primary" 
              size="small" 
              style="float:right"
              @click="_openChooseProductModal"
            >
              <i class="el-icon-plus"></i>选择商品
            </el-button>
          </div>
          <el-table
            :data="assetInventoryInInfo.inoutOrderProducts"
            border
            style="width:100%"
          >
            <el-table-column prop="productId" label="编号" align="center" />
            <el-table-column prop="prodName" label="名称" align="center" />
            <el-table-column prop="defaultSpecValue.specName" label="规格" align="center" />
            <el-table-column prop="defaultSpecValue.price" label="单价" align="center" />
            <el-table-column prop="quantity" label="账面数量" align="center" />
            <el-table-column label="盘点数量" align="center">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.invQuantity"
                  type="number"
                  @blur="_computeData(scope.row)"
                />
              </template>
            </el-table-column>
            <el-table-column label="将过期" align="center">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.willExpire"
                  type="number"
                  @blur="_computeData(scope.row)"
                />
              </template>
            </el-table-column>
            <el-table-column label="耗损" align="center">
              <template slot-scope="scope">
                <el-input
                  v-model.number="scope.row.attrition"
                  type="number"
                  @blur="_computeData(scope.row)"
                />
              </template>
            </el-table-column>
            <el-table-column prop="invProfit" label="盘盈" align="center" />
            <el-table-column prop="invLoss" label="盘亏" align="center" />
            <el-table-column prop="invProfitMoney" label="盘盈金额" align="center" />
            <el-table-column prop="invLossMoney" label="盘亏金额" align="center" />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="_deleteProduct(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-row style="margin-top:20px">
      <el-col :span="24">
        <div style="float:right">
          <el-button 
            type="warning" 
            style="margin-right:20px"
            @click="_goBack"
          >取消</el-button>
          <el-button 
            type="primary" 
            @click="_doAssetInventory"
          >提交</el-button>
        </div>
      </el-col>
    </el-row>

    <choose-product-and-spec ref="chooseProductModal" @chooseProduct="handleChooseProduct" />
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { saveAssetInventory, queryShopHouse } from '@/api/goods/assetInventoryApi'
import ChooseProductAndSpec from '@/components/goods/chooseProductAndSpec'

export default {
  components: {
    ChooseProductAndSpec
  },
  data() {
    return {
      assetInventoryInInfo: {
        shId: '',
        invTime: '',
        shopHouses: [],
        inoutOrderProducts: [],
        remark: '',
        shopId: getShopId()
      }
    }
  },
  created() {
    this._listShopHouses()
  },
  methods: {
    _doAssetInventory() {
      const _inoutOrderProducts = this.assetInventoryInInfo.inoutOrderProducts
      if (_inoutOrderProducts.length < 1) {
        this.$message.warning('请选择商品')
        return
      }
      
      _inoutOrderProducts.forEach(item => {
        item.valueId = item.defaultSpecValue.valueId
        item.specName = item.defaultSpecValue.specName
      })

      saveAssetInventory(this.assetInventoryInInfo)
        .then(response => {
          this.$message.success(response.msg)
          this._goBack()
        })
        .catch(error => {
          this.$message.error(error)
        })
    },
    _openChooseProductModal() {
      if (!this.assetInventoryInInfo.shId) {
        this.$message.warning('请先选择仓库')
        return
      }
      this.$refs.chooseProductModal.open({
        shId: this.assetInventoryInInfo.shId
      })
    },
    handleChooseProduct(product) {
      product.invProfit = 0
      product.invLoss = 0
      product.invProfitMoney = 0
      product.invLossMoney = 0
      product.invQuantity = 0
      product.willExpire = 0
      product.attrition = 0
      product.quantity = product.defaultSpecValue.stock
      this.assetInventoryInInfo.inoutOrderProducts.push(product)
    },
    _goBack() {
      this.$router.go(-1)
    },
    _deleteProduct(product) {
      const index = this.assetInventoryInInfo.inoutOrderProducts.indexOf(product)
      if (index > -1) {
        this.assetInventoryInInfo.inoutOrderProducts.splice(index, 1)
      }
    },
    _listShopHouses() {
      queryShopHouse({
        page: 1,
        row: 100,
        shopId: this.assetInventoryInInfo.shopId
      }).then(response => {
        this.assetInventoryInInfo.shopHouses = response.data
      }).catch(error => {
        console.log('请求失败处理', error)
      })
    },
    _computeData(product) {
      product.invProfit = parseInt(product.invQuantity) - parseInt(product.quantity)
      if (product.invProfit < 0) {
        product.invProfit = 0
      }
      product.invLoss = parseInt(product.quantity) - parseInt(product.invQuantity)
      if (product.invLoss < 0) {
        product.invLoss = 0
      }
      product.invProfitMoney = product.invProfit * parseFloat(product.defaultSpecValue.price)
      product.invLossMoney = product.invLoss * parseFloat(product.defaultSpecValue.price)
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
.form-container {
  padding: 20px;
}
.box-card {
  margin-bottom: 20px;
}
</style>